import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/client";

export const useTicketPriorities = (domain) => {
  const [priorities, setPriorities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPriorities = useCallback(async () => {
    if (!domain) {
      setPriorities([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await apiClient.get(`/api/ticketpriorities?domain=${encodeURIComponent(domain)}`);
      setPriorities(res.data || []);
    } catch (err) {
      console.error("Failed to load ticket priorities:", err);
      setError(err.message || "Failed to load priorities");
      setPriorities([]);
    } finally {
      setLoading(false);
    }
  }, [domain]);

  useEffect(() => {
    fetchPriorities();
  }, [fetchPriorities]);

  return { priorities, loading, error };
};